import React from 'react';
import { FormattedNumber } from 'react-intl';

// This component exists to prevent typing eslint-disable-next-line every time
// react-intl will probably never change it (https://github.com/yahoo/react-intl/issues/785)
function FormattedCurrency(props) {
  return (
    <FormattedNumber
      // eslint-disable-next-line react/style-prop-object
      style="currency"
      currency="BRL" // TODO: do not hard code this
      {...props}
    />
  );
}

export default FormattedCurrency;



// WEBPACK FOOTER //
// ./src/site-render/src/FormattedCurrency/FormattedCurrency.js